import React from "react"
import { css } from "react-emotion"
import { StaticQuery, Link, graphql } from "gatsby"
import styles from "./layout.module.css"
import {Helmet} from "react-helmet";

const ListLink = props => (
  <li style={{ display: `inline-block`, marginRight: `1rem` }}>
    <Link to={props.to}>{props.children}</Link>
  </li>
)

export default ({ children }) => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
}
    render={data => (
      <div>  
        <Helmet>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/flexboxgrid/6.3.1/flexboxgrid.min.css" type="text/css"/>
        </Helmet>  
         <div style={{ margin: `0 auto`, maxWidth: 650, padding: `1.25rem 1rem` }}>
            <header style={{ marginBottom: `1.5rem` }}>
              <Link style={{ color: `#2e3131`, textDecoration: `none` }} to={`/`}><h3 style={{ display: `inline` }}>{data.site.siteMetadata.title}</h3></Link>
              <ul style={{ listStyle: `none`, float: `right` }}>
                <ListLink to={`/about/`}>About</ListLink>
              </ul>
            </header>
            <div className={css`
            padding-top: 2rem;
          ` }>
              {children}
            </div>
          </div>
      </div>
    )}
  />
)
